<template>
  <!--工业园区表单-->
  <div class="otherBox">
    <el-form ref="otherForm" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="园区全称" prop="name">
        <el-input v-model="form.name" style="width:400px" placeholder="园区全称"></el-input>
      </el-form-item>
      <el-form-item label="注册地址" prop="address">
        <dataTree @change='changeId' :defaultData='defaultPointerData'></dataTree>
        <el-input v-model="form.address" style="width:400px;display:block;margin-top:22px" placeholder="街道详细地址"></el-input>
      </el-form-item>
      <el-form-item label="级别" label-width="120px" prop="subType">
        <el-select v-model="form.subType" placeholder="请选择">
          <el-option v-for="item in subTypeArr" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人" label-width="120px" prop="linkMan">
        <el-input v-model="form.linkMan" placeholder="联系人名称" class="input-w180"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" label-width="120px" prop="phone">
        <el-input v-model="form.phone" placeholder="联系电话" class="input-w180"></el-input>
      </el-form-item>
      <el-form-item label="中心坐标" label-width="120px" prop="latitude">
        <el-button @click="showMap.state = true">地图选点</el-button>
        <span style="margin-left: 5px">东经：{{form.longitude | formatDegree}}，北纬：{{form.latitude | formatDegree}}</span>
<!--        <el-input style="width:150px" v-model.number="form.longitude" placeholder="经度"></el-input>-->
<!--        <el-input style="width:150px" v-model.number="form.latitude" placeholder="纬度"></el-input>-->
        <mapPointer :show="showMap" :source='{lat:form.latitude,lng:form.longitude}' @change="confirm"></mapPointer>
      </el-form-item>
      <el-form-item label="所属区划" prop="regions">
        <!-- <dataTreeboth @change="changeRegion" :defaultDataval='defaultPointerDataval'></dataTreeboth> -->
        <dataTree @change='changeRegion' :defaultData='defaultPointerDataval'></dataTree>
        <p>注：所属区划决定了备案流程，请确定后操作</p>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import mapPointer from '../../view/component/MapPointer.vue'
import dataTree from '../../view/component/Datatree.vue'
import dataTreeboth from '../../view/component/Datatreeboth.vue'
import account from '../../data/basic/plan/company.js'
import { mapState } from 'vuex'
export default {
  components: {
    mapPointer,
    dataTree,
    dataTreeboth
  },
  data() {
    return {
      defaultPointerDataval: [],
      subTypeArr: [{
          value: 1,
          label: '国家级 '
        },
        {
          value: 2,
          label: '省级'
        },
        {
          value: 3,
          label: '市级'
        },
        {
          value: 4,
          label: '县级'
        }
      ],
      showMap: {
        state: false
      },
      latlng: {
        lat: '',
        lng: ''
      },
      // 验证
      rules: {
        name: [{
          required: true,
          message: '请输入园区全称的名称',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请输入街道详细地址',
          trigger: 'blur'
        }],
        subType: [{
          type: 'number',
          required: true,
          message: '请选择园区保护级别',
          trigger: 'change'
        }],
        linkMan: [{
          required: true,
          message: '请输入联系人的名称',
          trigger: 'blur'
        }],
        phone: [{
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          },
          {
            pattern: /^1\d{10}$/,
            message: '手机号格式错误',
            trigger: 'blur'
          }
        ],
        latitude: [{
          type: 'number',
          required: true,
          message: '请选择地图坐标',
          trigger: 'change'
        }],
        regions: [{
          type: 'array',
          required: true,
          message: '请选择区划',
          trigger: 'change'
        }],
      },
      form: {
        // 地址
        address: '',
        // 市代码
        city: '',
        // 市名称
        cityName: '',
        // 成员数量
        count: '',
        // 县代码
        county: '',
        // 区/县名称
        countyName: '',
        // 创建时间
        createtime: '',
        id: '',
        latitude: '',
        // 纬度
        longitude: '',
        // 机构名称
        name: '',
        // 电话
        phone: '',
        // 省代码
        province: '',
        // 省名称
        provinceName: '',
        // 所属管辖范围,1=不跨区县，2=跨区县不跨市，3=跨区县、市，默认值不跨区县
        regionType: 1,
        //
        regions: [],
        // 我的角色,0=管理员，1=普通用户
        role: 1, // 我的角色,0=管理员，1=普通用户 ,
        // 子类型，工业园区： 1 = 省级， 2=省级，3= 市级，4=县级；
        subType: '',
        // integer, optional, read only): 机构类型，0=企业，1=政府单位，2=工业园区，3=饮用水源地,4=其他专项
        type: '',
        linkMan: '',
      },
      defaultPointerData: []
    }
  },
  props: {
    modifyenf: {
      type: Object
    },
    isUpdata: {
      type: Boolean
    }
  },
  computed: {
    ...mapState({
      dataParklist(state) {
        return state.dataParklist
      },
    })
  },
  created() {
    if (this.isUpdata) {
      if (!this.dataParklist) {
        this.$router.replace('/')
      } else {
        this.form = JSON.parse(JSON.stringify(this.dataParklist))
        this.defaultPointerData = [this.form.province, this.form.city, this.form.county]
        this.defaultPointerDataval = this.form.regions?[this.getRegionCode(this.form.regions[0].province),this.getRegionCode(this.form.regions[0].city),this.getRegionCode(this.form.regions[0].county[0])]:[]
      }
    }
  },
  mounted() {
    // 初始化城市列表
    // 初始化区县列表
    this.getCountyList()
    this.initData()
  },
  methods: {
    getRegionCode(val){
      if(!val){
        return null
      }
      return val.code;
    },
    // 数据的类型
    changeRegionId(val) {
      this.form.regionType = val
    },
    // 获取所属区划数据
    changeRegion(val) {
      let provinceData = val[0],
        cityData = val[1],
        countyData = val[2]
      if (provinceData && !cityData && !countyData) {
        this.form.regionType = 1
        this.RegionPartition = {
          province: {
            code: provinceData
          }
        }
      }
      else if (provinceData && cityData && !countyData) {
        this.form.regionType = 1
        this.RegionPartition = {
          province: {
            code: provinceData
          },
          city: {
            code: cityData
          }
        }
      }
      else if (provinceData && cityData && countyData) {
        this.form.regionType = 1
        this.RegionPartition = {
          province: {
            code: provinceData
          },
          city: {
            code: cityData
          },
          county: [{
            code: countyData
          }]
        }
      }
      this.form.regions = [this.RegionPartition]
    },
    // 获取三级联动的ID
    changeId(val) {
      if (val.length === 2) {
        this.form.county = ''
        this.form.city = val[1]
        this.form.province = val[0]
      } else {
        this.form.county = val[2]
        this.form.city = val[1]
        this.form.province = val[0]
      }
    },
    // 初始化Form表单数据
    initData() {
      if (this.data) {
        this.form = JSON.parse(JSON.stringify(this.data))
      }
    },
    // 提交表单
    onSubmitpark() {
      this.$refs['otherForm'].validate((valid) => {
        if (valid) {
          this.$emit('change', this.form)
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    // 取消输入的
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 经纬度
    mapclick(val) {
      let lat = val.latlng.lat,
        lng = val.latlng.lng
      this.latlng.lat = lat
      this.latlng.lng = lng
    },
    // 执行确认操作
    confirm(val) {
      this.form.latitude = Math.floor(val.lat * 1000000) / 1000000
      this.form.longitude = Math.floor(val.lng * 1000000) / 1000000
    },
    // 执行取消或者关闭
    cancel(val) {
      this.showMap.state = val
    },
    // 获取区县列表
    getCountyList() {
      (async() => {
        this.statelist = await account.get_tree()
        this.pro = this.statelist;
        this.city = this.pro[0]['children'];
        this.county = this.city[0]['children'];
      })()
    },
  }
}

</script>
<style lang="stylus" scoped>
.otherBox {
  clear: both;
  padding-bottom: 20px;
}

.address-p1 {
  display: block;
  width: 400px;
}

.address-p2 {
  display: block;
  width: 400px;
}

.input-w180 {
  width: 180px;
}

.input-w140 {
  width: 140px;
}

.input-w150 {
  width: 140px;
  margin-left: 20px;
}

</style>



// WEBPACK FOOTER //
// Parkform.vue?a3f5a046